'use client'

import { create } from 'zustand'

interface MaintenanceState {
  shouldRedirectToMaintenance: boolean
}

interface MaintenanceStateAction {
  triggerMaintenanceRedirect: () => void
  resetMaintenanceState: () => void
}

export const useMaintenanceStore = create<MaintenanceState & MaintenanceStateAction>()((set) => {
  return {
    shouldRedirectToMaintenance: false,
    triggerMaintenanceRedirect: () => set({ shouldRedirectToMaintenance: true }),
    resetMaintenanceState: () => set({ shouldRedirectToMaintenance: false }),
  }
})
